// components/ToasterProvider.tsx
'use client';
import { useSelector } from 'react-redux';
import { RootState } from '@/components/default/redux/store';
import Custom404 from '../404/Custom404';

const LayoutProvider = ({
    children,
}: Readonly<{
    children: React.ReactNode;
}>) => {
    const pageLoading = useSelector((state: RootState) => state.layout.pageLoading);
    const subDomain = useSelector((state: RootState) => state.domain.subDomain);
    const isValidSubDomain = useSelector((state: RootState) => state.domain.isValidSubDomain);
    const mainDomain = useSelector((state: RootState) => state.domain.mainDomain);
    const isValidMainDomain = useSelector((state: RootState) => state.domain.isValidMainDomain);

    const customDomain = useSelector((state: RootState) => state.domain.customDomain);
    const isValidCustomDomain = useSelector((state: RootState) => state.domain.isValidCustomDomain);
    const isPageNotFound = useSelector((state: RootState) => state.ui.isPageNotFound);

    // console.log('isPageNotFound', isPageNotFound);
    if (isPageNotFound) return <Custom404 />;

    if (!pageLoading) return <></>; // Don't render anything if page is not loading

    // console.log('pageLoading: ', pageLoading);
    // console.log('Main domain:', mainDomain);
    // console.log('Is valid main domain:', isValidMainDomain);
    // console.log('Subdomain:', subDomain);
    // console.log('Is valid subdomain:', isValidSubDomain);
    // console.log('Custom domain:', customDomain);
    // console.log('Is valid custom domain:', isValidCustomDomain);

    // If main domain is not valid, show an error message
    if (mainDomain && !isValidMainDomain) {
        return (
            <div className="flex flex-col items-center justify-center h-screen text-center px-4">
                <h1 className="text-3xl font-extrabold text-red-600 mb-2">Invalid Domain</h1>
                <p className="text-lg text-gray-600 max-w-md">It looks like you’re accessing the site from an invalid domain. Please verify that you’re using the correct URL.</p>
            </div>
        );
    }
    // If subdomain is not valid, show an error message
    if (subDomain && !isValidSubDomain) {
        return (
            <div className="flex flex-col items-center justify-center h-screen text-center px-4">
                <h1 className="text-3xl font-extrabold text-red-600 mb-2">Subdomain Not Found</h1>
                <p className="text-lg text-gray-600 max-w-md">We couldn’t find the subdomain you’re trying to access. Please check your URL and try again.</p>
            </div>
        );
    }

    // If custom domain is not valid, show an error message
    if (customDomain && !isValidCustomDomain) {
        return (
            <div className="flex flex-col items-center justify-center h-screen text-center px-4">
                <h1 className="text-3xl font-extrabold text-red-600 mb-2">You Domain Not Found</h1>
                <p className="text-lg text-gray-600 max-w-md">We couldn’t find you’re trying to access. Please check your URL and try again.</p>
            </div>
        );
    }

    if (!mainDomain && !subDomain && !customDomain) {
        return (
            <div className="flex flex-col items-center justify-center h-screen text-center px-4">
                <h1 className="text-3xl font-extrabold text-red-600 mb-2">Domain Not Found</h1>
                <p className="text-lg text-gray-600 max-w-md">We couldn’t find the domain you’re trying to access. Please check your URL and try again.</p>
            </div>
        );
    }
    // If page is loading, render the children components
    return <>{children}</>;
};

export default LayoutProvider;
